import ".././styles/Constitution.css";
import { HashLink as Link } from 'react-router-hash-link';
import React, { useState } from "react";

import Article1 from "../components/constitution/Article1.js";
import Article2 from "../components/constitution/Article2.js";
import Article3 from "../components/constitution/Article3.js";
import Article4 from "../components/constitution/Article4.js";
import Article5 from "../components/constitution/Article5.js";
import Article6 from "../components/constitution/Article6.js";
import Article7 from "../components/constitution/Article7.js";
import Article8 from "../components/constitution/Article8.js";
import Article9 from "../components/constitution/Article9.js";
import Article10 from "../components/constitution/Article10.js";
import Article11 from "../components/constitution/Article11.js";
import Provisions from "../components/constitution/Provisions.js";

function Constitution(){
    const [active, setActive] = React.useState(1);
    const goToArticle = document.getElementById("constitution-active-view");

    const handleRadioChange = (viewNumber) => {
        setActive(viewNumber);
        goToArticle.scrollIntoView({behavior: "smooth", block: "start"});
    };

    const ActiveView = () => {
        switch (active) {
            case 1:
                return <Article1 />;
            case 2:
                return <Article2 />;
            case 3:
                return <Article3 />;
            case 4:
                return <Article4 />;
            case 5:
                return <Article5 />;
            case 6:
                return <Article6 />;
            case 7:
                return <Article7 />;
            case 8:
                return <Article8 />;
            case 9:
                return <Article9 />;
            case 10:
                return <Article10 />;
            case 11:
                return <Article11 />;
            case 12:
                return <Provisions />;
            default: 
                return <Article1 />;
        }
    };

    return(
        <>
            <div className="container">
                <div className="constitution-banner-container" id="banner">
                    <div className="constitution-banner">
                        <h1>Constitution & By-Laws</h1>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="sub-container article-list constitution">
                    <h3>Table of Content</h3> <br/><br/>
                    <div id="table-of-content">
                        <input
                            type="radio"
                            name="answer"
                            id="a1-button"
                            value="1" 
                            checked={active === 1} 
                            onChange={() => handleRadioChange(1)} 
                        />
                        <label htmlFor="a1-button"><p>Article I: Preamble</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a2-button"
                            value="2"
                            checked={active === 2}
                            onChange={() => handleRadioChange(2)}
                        />
                        <label htmlFor="a2-button"><p>Article II: Defintions & Interpretations</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a3-button"
                            value="3"
                            checked={active === 3}
                            onChange={() => handleRadioChange(3)}
                        />
                        <label htmlFor="a3-button"><p>Article III: Members of the Corporation</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a4-button"
                            value="4"
                            checked={active === 4}
                            onChange={() => handleRadioChange(4)}
                        />
                        <label htmlFor="a4-button"><p>Article IV: Governing Board</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a5-button"
                            value="5"
                            checked={active === 5}
                            onChange={() => handleRadioChange(5)}
                        />
                        <label htmlFor="a5-button"><p>Article V: Officers and their Accountabilities</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a6-button"
                            value="6"
                            checked={active === 6}
                            onChange={() => handleRadioChange(6)}
                        />
                        <label htmlFor="a6-button"><p>Article VI: Meetings of the Corporation</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a7-button"
                            value="7"
                            checked={active === 7}
                            onChange={() => handleRadioChange(7)}
                        />
                        <label htmlFor="a7-button"><p>Article VII: Committees</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a8-button"
                            value="8"
                            checked={active === 8}
                            onChange={() => handleRadioChange(8)}
                        />
                        <label htmlFor="a8-button"><p>Article VIII: Borrowing Powers</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a9-button"
                            value="9"
                            checked={active === 9}
                            onChange={() => handleRadioChange(9)}
                        />
                        <label htmlFor="a9-button"><p>Article IX: Finances and Reports</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a10-button"
                            value="10"
                            checked={active === 10}
                            onChange={() => handleRadioChange(10)}
                        />
                        <label htmlFor="a10-button"><p>Article X: Official Seal of the Corporation</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="a11-button"
                            value="11"
                            checked={active === 11}
                            onChange={() => handleRadioChange(11)}
                        />
                        <label htmlFor="a11-button"><p>Article XI: Amendment and Dissolution</p></label>

                        <input
                            type="radio"
                            name="answer"
                            id="gp-button"
                            value="12"
                            checked={active === 12}
                            onChange={() => handleRadioChange(12)}
                        />
                        <label htmlFor="gp-button"><p>General Provisions</p></label>
                    </div>
                </div>
            </div>
            <div id="constitution-active-view">
                {ActiveView()}
            </div>

        </>
    );
}

export default Constitution;